var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"lp-checkbox",class:{ 'is-invalid': !!_vm.error }},[_c('input',_vm._b({attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"lp-checkbox__label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }